"use client";

import { useState } from "react";
import { cn } from "@udecode/cn";
import { useEditorPlugin, useEditorSelector } from "@udecode/plate/react";
import { FontFamilyPlugin } from "@udecode/plate-font/react";
import { Popover, PopoverContent, PopoverTrigger } from "./popover"; // Your popover UI components

const DEFAULT_FONT_FAMILY = "Arial";

const FONT_FAMILY = [
  "Arial",
  "Courier New",
  "Times New Roman",
  "sans-serif",
  "serif",
  "monospace",
] as const;

type FontFamily = (typeof FONT_FAMILY)[number];

export function FontFamilyToolbarButton() {
  const [inputValue, setInputValue] = useState<FontFamily>(DEFAULT_FONT_FAMILY);
  const [isFocused, setIsFocused] = useState(false);

  const { api, editor } = useEditorPlugin(FontFamilyPlugin);

  const cursorFontFamily = useEditorSelector(() => {
    const marks = api.marks();
    const fontFamily = marks?.[FontFamilyPlugin.key];
    return fontFamily ?? DEFAULT_FONT_FAMILY;
  }, []);

  const handleInputChange = () => {
    const newFamily = inputValue;
    console.log("newFamily");
    console.log(newFamily);
    if (!FONT_FAMILY.includes(newFamily)) {
      editor.tf.focus();
      return;
    }
    if (newFamily !== cursorFontFamily) {
      editor.tf.addMarks({ [FontFamilyPlugin.key]: newFamily });
    }
    editor.tf.focus();
  };

  const displayValue = isFocused ? inputValue : cursorFontFamily;

  return (
    <div className="flex h-7 items-center gap-1 rounded-md bg-muted/60 p-0">
      <Popover open={isFocused} modal={false}>
        <PopoverTrigger asChild>
          <input
            className={cn(
              "w-30 h-full shrink-0 bg-muted/60 px-1 text-center text-sm hover:bg-muted"
            )}
            value={displayValue}
            style={{ fontFamily: displayValue }}
            onBlur={() => {
              console.log("I am called here")
              setIsFocused(false);
              handleInputChange();
            }}
            onChange={(e) => {
              console.log("I am called here 2")
              setInputValue(e.target.value as FontFamily)
            }}
            onFocus={(e) => {
              console.log("I am called here 3", e.target.value)
              setIsFocused(true);
              console.log(cursorFontFamily);
              setInputValue(cursorFontFamily as FontFamily);
            }}
            onKeyDown={(e) => {
              console.log("I am called here 4")
              if (e.key === "Enter") {
                e.preventDefault();
                console.log("e.target.value")
                console.log(e.target.value)
                handleInputChange();
              }
            }}
            data-plate-focus="true"
            type="text"
          />
        </PopoverTrigger>
        <PopoverContent
          className="w-30 px-px py-1"
          onOpenAutoFocus={(e) => e.preventDefault()}
        >
          {FONT_FAMILY.map((font) => (
            <button
              key={font}
              className={cn(
                "flex h-8 w-full items-center justify-center text-sm hover:bg-accent data-[highlighted=true]:bg-accent"
              )}
              style={{ fontFamily: font }}
              onClick={() => {
                console.log("I am called here 5")
                editor.tf.addMarks({ [FontFamilyPlugin.key]: font });
                console.log("I am called here", cursorFontFamily)
                setInputValue(cursorFontFamily as FontFamily);
                setIsFocused(false);
              }}
              onKeyDown={(e) => {
                console.log("font ----");
                console.log(font);
              }}
              data-highlighted={font === displayValue}
              type="button"
            >
              {font}
            </button>
          ))}
        </PopoverContent>
      </Popover>
    </div>
  );
}
